import { render } from "./piRemarks.vue?vue&type=template&id=94be70ca"
import script from "./piRemarks.vue?vue&type=script&lang=js"
export * from "./piRemarks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__